const countries = {
	AF: {
		da: { name: 'Afghanistan' },
		en: { name: 'Afghanistan' },
		de: { name: 'Afghanistan' },
		fo: { name: 'Afganistan' },
		nb: { name: 'Afghanistan' },
		sv: { name: 'Afghanistan' }
	},
	AL: {
		da: { name: 'Albanien' },
		en: { name: 'Albania' },
		de: { name: 'Albanien' },
		fo: { name: 'Albania' },
		nb: { name: 'Albania' },
		sv: { name: 'Albanien' }
	},
	DZ: {
		da: { name: 'Algeriet' },
		en: { name: 'Algeria' },
		de: { name: 'Algerien' },
		fo: { name: 'Algeria' },
		nb: { name: 'Algerie' },
		sv: { name: 'Algeriet' }
	},
	AS: {
		da: { name: 'Amerikansk Samoa' },
		en: { name: 'American Samoa' },
		de: { name: 'Amerikanisch-Samoa' },
		fo: { name: 'Amerikanskt Samoa' },
		nb: { name: 'Amerikansk Samoa' },
		sv: { name: 'Amerikanska Samoa' }
	},
	UM: {
		da: { name: 'Amerikanske oversøiske øer' },
		en: { name: 'U.S. Outlying Islands' },
		de: { name: 'Amerikanische Überseeinseln' },
		fo: { name: 'USA útoyggjar' },
		nb: { name: 'USAs ytre øyer' },
		sv: { name: 'USA:s yttre öar' }
	},
	AD: {
		da: { name: 'Andorra' },
		en: { name: 'Andorra' },
		de: { name: 'Andorra' },
		fo: { name: 'Andorra' },
		nb: { name: 'Andorra' },
		sv: { name: 'Andorra' }
	},
	AO: {
		da: { name: 'Angola' },
		en: { name: 'Angola' },
		de: { name: 'Angola' },
		fo: { name: 'Angola' },
		nb: { name: 'Angola' },
		sv: { name: 'Angola' }
	},
	AI: {
		da: { name: 'Anguilla' },
		en: { name: 'Anguilla' },
		de: { name: 'Anguilla' },
		fo: { name: 'Anguilla' },
		nb: { name: 'Anguilla' },
		sv: { name: 'Anguilla' }
	},
	AQ: {
		da: { name: 'Antarktis' },
		en: { name: 'Antarctica' },
		de: { name: 'Antarktis' },
		fo: { name: 'Antarktis' },
		nb: { name: 'Antarktis' },
		sv: { name: 'Antarktis' }
	},
	AG: {
		da: { name: 'Antigua og Barbuda' },
		en: { name: 'Antigua and Barbuda' },
		de: { name: 'Antigua und Barbuda' },
		fo: { name: 'Antigua og Barbuda' },
		nb: { name: 'Antigua og Barbuda' },
		sv: { name: 'Antigua och Barbuda' }
	},
	AR: {
		da: { name: 'Argentina' },
		en: { name: 'Argentina' },
		de: { name: 'Argentinien' },
		fo: { name: 'Argentina' },
		nb: { name: 'Argentina' },
		sv: { name: 'Argentina' }
	},
	AM: {
		da: { name: 'Armenien' },
		en: { name: 'Armenia' },
		de: { name: 'Armenien' },
		fo: { name: 'Armenia' },
		nb: { name: 'Armenia' },
		sv: { name: 'Armenien' }
	},
	AW: {
		da: { name: 'Aruba' },
		en: { name: 'Aruba' },
		de: { name: 'Aruba' },
		fo: { name: 'Aruba' },
		nb: { name: 'Aruba' },
		sv: { name: 'Aruba' }
	},
	AZ: {
		da: { name: 'Aserbajdsjan' },
		en: { name: 'Azerbaijan' },
		de: { name: 'Aserbaidschan' },
		fo: { name: 'Aserbajdsjan' },
		nb: { name: 'Aserbajdsjan' },
		sv: { name: 'Azerbajdzjan' }
	},
	AU: {
		da: { name: 'Australien' },
		en: { name: 'Australia' },
		de: { name: 'Australien' },
		fo: { name: 'Avstralia' },
		nb: { name: 'Australia' },
		sv: { name: 'Australien' }
	},
	BS: {
		da: { name: 'Bahamas' },
		en: { name: 'Bahamas' },
		de: { name: 'Bahamas' },
		fo: { name: 'Bahamas' },
		nb: { name: 'Bahamas' },
		sv: { name: 'Bahamas' }
	},
	BH: {
		da: { name: 'Bahrain' },
		en: { name: 'Bahrain' },
		de: { name: 'Bahrain' },
		fo: { name: 'Bahrain' },
		nb: { name: 'Bahrain' },
		sv: { name: 'Bahrain' }
	},
	BD: {
		da: { name: 'Bangladesh' },
		en: { name: 'Bangladesh' },
		de: { name: 'Bangladesch' },
		fo: { name: 'Bangladesj' },
		nb: { name: 'Bangladesh' },
		sv: { name: 'Bangladesh' }
	},
	BB: {
		da: { name: 'Barbados' },
		en: { name: 'Barbados' },
		de: { name: 'Barbados' },
		fo: { name: 'Barbados' },
		nb: { name: 'Barbados' },
		sv: { name: 'Barbados' }
	},
	BE: {
		da: { name: 'Belgien' },
		en: { name: 'Belgium' },
		de: { name: 'Belgien' },
		fo: { name: 'Belgia' },
		nb: { name: 'Belgia' },
		sv: { name: 'Belgien' }
	},
	BZ: {
		da: { name: 'Belize' },
		en: { name: 'Belize' },
		de: { name: 'Belize' },
		fo: { name: 'Belis' },
		nb: { name: 'Belize' },
		sv: { name: 'Belize' }
	},
	BJ: {
		da: { name: 'Benin' },
		en: { name: 'Benin' },
		de: { name: 'Benin' },
		fo: { name: 'Benin' },
		nb: { name: 'Benin' },
		sv: { name: 'Benin' }
	},
	BM: {
		da: { name: 'Bermuda' },
		en: { name: 'Bermuda' },
		de: { name: 'Bermuda' },
		fo: { name: 'Bermuda' },
		nb: { name: 'Bermuda' },
		sv: { name: 'Bermuda' }
	},
	BT: {
		da: { name: 'Bhutan' },
		en: { name: 'Bhutan' },
		de: { name: 'Bhutan' },
		fo: { name: 'Butan' },
		nb: { name: 'Bhutan' },
		sv: { name: 'Bhutan' }
	},
	BO: {
		da: { name: 'Bolivia' },
		en: { name: 'Bolivia' },
		de: { name: 'Bolivien' },
		fo: { name: 'Bolivia' },
		nb: { name: 'Bolivia' },
		sv: { name: 'Bolivia' }
	},
	BA: {
		da: { name: 'Bosnien-Hercegovina' },
		en: { name: 'Bosnia and Herzegovina' },
		de: { name: 'Bosnien und Herzegowina' },
		fo: { name: 'Bosnia-Hercegovina' },
		nb: { name: 'Bosnia-Hercegovina' },
		sv: { name: 'Bosnien och Hercegovina' }
	},
	BW: {
		da: { name: 'Botswana' },
		en: { name: 'Botswana' },
		de: { name: 'Botswana' },
		fo: { name: 'Botsvana' },
		nb: { name: 'Botswana' },
		sv: { name: 'Botswana' }
	},
	BV: {
		da: { name: 'Bouvetøen' },
		en: { name: 'Bouvet Island' },
		de: { name: 'Bouvetinsel' },
		fo: { name: 'Bouvetoyggin' },
		nb: { name: 'Bouvetøya' },
		sv: { name: 'Bouvetön' }
	},
	BR: {
		da: { name: 'Brasilien' },
		en: { name: 'Brazil' },
		de: { name: 'Brasilien' },
		fo: { name: 'Brasil' },
		nb: { name: 'Brasil' },
		sv: { name: 'Brasilien' }
	},
	BN: {
		da: { name: 'Brunei' },
		en: { name: 'Brunei' },
		de: { name: 'Brunei' },
		fo: { name: 'Brunei' },
		nb: { name: 'Brunei' },
		sv: { name: 'Brunei' }
	},
	BG: {
		da: { name: 'Bulgarien' },
		en: { name: 'Bulgaria' },
		de: { name: 'Bulgarien' },
		fo: { name: 'Bulgaria' },
		nb: { name: 'Bulgaria' },
		sv: { name: 'Bulgarien' }
	},
	BF: {
		da: { name: 'Burkina Faso' },
		en: { name: 'Burkina Faso' },
		de: { name: 'Burkina Faso' },
		fo: { name: 'Burkina Faso' },
		nb: { name: 'Burkina Faso' },
		sv: { name: 'Burkina Faso' }
	},
	BI: {
		da: { name: 'Burundi' },
		en: { name: 'Burundi' },
		de: { name: 'Burundi' },
		fo: { name: 'Burundi' },
		nb: { name: 'Burundi' },
		sv: { name: 'Burundi' }
	},
	KH: {
		da: { name: 'Cambodja' },
		en: { name: 'Cambodia' },
		de: { name: 'Kambodscha' },
		fo: { name: 'Kambodja' },
		nb: { name: 'Kambodsja' },
		sv: { name: 'Kambodja' }
	},
	CM: {
		da: { name: 'Cameroun' },
		en: { name: 'Cameroon' },
		de: { name: 'Kamerun' },
		fo: { name: 'Kamerun' },
		nb: { name: 'Kamerun' },
		sv: { name: 'Kamerun' }
	},
	CA: {
		da: { name: 'Canada' },
		en: { name: 'Canada' },
		de: { name: 'Kanada' },
		fo: { name: 'Kanada' },
		nb: { name: 'Canada' },
		sv: { name: 'Kanada' }
	},
	KY: {
		da: { name: 'Caymanøerne' },
		en: { name: 'Cayman Islands' },
		de: { name: 'Kaimaninseln' },
		fo: { name: 'Caymanoyggjar' },
		nb: { name: 'Caymanøyene' },
		sv: { name: 'Caymanöarna' }
	},
	CL: {
		da: { name: 'Chile' },
		en: { name: 'Chile' },
		de: { name: 'Chile' },
		fo: { name: 'Kili' },
		nb: { name: 'Chile' },
		sv: { name: 'Chile' }
	},
	CC: {
		da: { name: 'Cocosøerne' },
		en: { name: 'Cocos (Keeling) Islands' },
		de: { name: 'Kokosinseln' },
		fo: { name: 'Cocosoyggjar' },
		nb: { name: 'Cocosøyene' },
		sv: { name: 'Kokosöarna' }
	},
	CO: {
		da: { name: 'Colombia' },
		en: { name: 'Colombia' },
		de: { name: 'Kolumbien' },
		fo: { name: 'Kolombia' },
		nb: { name: 'Colombia' },
		sv: { name: 'Colombia' }
	},
	KM: {
		da: { name: 'Comorerne' },
		en: { name: 'Comoros' },
		de: { name: 'Komoren' },
		fo: { name: 'Komoroyggjar' },
		nb: { name: 'Komorene' },
		sv: { name: 'Komorerna' }
	},
	CG: {
		da: { name: 'Congo-Brazzaville' },
		en: { name: 'Congo' },
		de: { name: 'Kongo' },
		fo: { name: 'Kongo' },
		nb: { name: 'Kongo' },
		sv: { name: 'Kongo' }
	},
	CD: {
		da: { name: 'Congo-Kinshasa' },
		en: { name: 'Democratic Republic of the Congo' },
		de: { name: 'Demokratische Republik Kongo' },
		fo: { name: 'Demokratiska Kongo' },
		nb: { name: 'Den demokratiske republikken Kongo' },
		sv: { name: 'Demokratiska republiken Kongo' }
	},
	CK: {
		da: { name: 'Cookøerne' },
		en: { name: 'Cook Islands' },
		de: { name: 'Cookinseln' },
		fo: { name: 'Cookoyggjar' },
		nb: { name: 'Cookøyene' },
		sv: { name: 'Cooköarna' }
	},
	CR: {
		da: { name: 'Costa Rica' },
		en: { name: 'Costa Rica' },
		de: { name: 'Costa Rica' },
		fo: { name: 'Kosta Rika' },
		nb: { name: 'Costa Rica' },
		sv: { name: 'Costa Rica' }
	},
	CU: {
		da: { name: 'Cuba' },
		en: { name: 'Cuba' },
		de: { name: 'Kuba' },
		fo: { name: 'Kuba' },
		nb: { name: 'Cuba' },
		sv: { name: 'Kuba' }
	},
	CW: {
		da: { name: 'Curaçao' },
		en: { name: 'Curaçao' },
		de: { name: 'Curaçao' },
		fo: { name: 'Curaçao' },
		nb: { name: 'Curaçao' },
		sv: { name: 'Curaçao' }
	},
	CY: {
		da: { name: 'Cypern' },
		en: { name: 'Cyprus' },
		de: { name: 'Zypern' },
		fo: { name: 'Kýpros' },
		nb: { name: 'Kypros' },
		sv: { name: 'Cypern' }
	},
	DK: {
		da: { name: 'Danmark' },
		en: { name: 'Denmark' },
		de: { name: 'Dänemark' },
		fo: { name: 'Danmark' },
		nb: { name: 'Danmark' },
		sv: { name: 'Danmark' }
	},
	VI: {
		da: { name: 'De Amerikanske Jomfruøer' },
		en: { name: 'U.S. Virgin Islands' },
		de: { name: 'Amerikanische Jungferninseln' },
		fo: { name: 'Amerikansku Jomfrúoyggjar' },
		nb: { name: 'De amerikanske jomfruøyene' },
		sv: { name: 'Amerikanska Jungfruöarna' }
	},
	VG: {
		da: { name: 'De Britiske Jomfruøer' },
		en: { name: 'British Virgin Islands' },
		de: { name: 'Britische Jungferninseln' },
		fo: { name: 'Bretlands Jomfrúoyggjar' },
		nb: { name: 'De britiske jomfruøyene' },
		sv: { name: 'Brittiska Jungfruöarna' }
	},
	AE: {
		da: { name: 'De Forenede Arabiske Emirater' },
		en: { name: 'United Arab Emirates' },
		de: { name: 'Vereinigte Arabische Emirate' },
		fo: { name: 'Sameindu Arabisku Emiratirnar' },
		nb: { name: 'De forente arabiske emirater' },
		sv: { name: 'Förenade Arabemiraten' }
	},
	TF: {
		da: { name: 'De Franske Besiddelser i Det Sydlige Indiske Ocean og Antarktis' },
		en: { name: 'French Southern Territories' },
		de: { name: 'Französische Süd- und Antarktisgebiete' },
		fo: { name: 'Fronsku sunnaru landaøki' },
		nb: { name: 'Franske sørterritorier' },
		sv: { name: 'Franska sydterritorierna' }
	},
	PS: {
		da: { name: 'De palæstinensiske områder' },
		en: { name: 'Palestinian Territories' },
		de: { name: 'Palästinensische Gebiete' },
		fo: { name: 'Palestinsku økini' },
		nb: { name: 'Palestinske områder' },
		sv: { name: 'Palestinska territorierna' }
	},
	BQ: {
		da: { name: 'De tidligere Nederlandske Antiller' },
		en: { name: 'Caribbean Netherlands' },
		de: { name: 'Karibische Niederlande' },
		fo: { name: 'Karibiska Niðurlond' },
		nb: { name: 'Karibiske Nederlandene' },
		sv: { name: 'Karibiska Nederländerna' }
	},
	CF: {
		da: { name: 'Den Centralafrikanske Republik' },
		en: { name: 'Central African Republic' },
		de: { name: 'Zentralafrikanische Republik' },
		fo: { name: 'Miðafrikanska Lýðveldið' },
		nb: { name: 'Den sentralafrikanske republikk' },
		sv: { name: 'Centralafrikanska republiken' }
	},
	DO: {
		da: { name: 'Den Dominikanske Republik' },
		en: { name: 'Dominican Republic' },
		de: { name: 'Dominikanische Republik' },
		fo: { name: 'Dominikanska Lýðveldið' },
		nb: { name: 'Den dominikanske republikk' },
		sv: { name: 'Dominikanska republiken' }
	},
	IO: {
		da: { name: 'Det Britiske Territorium i Det Indiske Ocean' },
		en: { name: 'British Indian Ocean Territory' },
		de: { name: 'Britisches Territorium im Indischen Ozean' },
		fo: { name: 'Bretlands Indiahavsoyggjar' },
		nb: { name: 'Britisk territorium i Indiahavet' },
		sv: { name: 'Brittiska territoriet i Indiska oceanen' }
	},
	DJ: {
		da: { name: 'Djibouti' },
		en: { name: 'Djibouti' },
		de: { name: 'Dschibuti' },
		fo: { name: 'Djibouti' },
		nb: { name: 'Djibouti' },
		sv: { name: 'Djibouti' }
	},
	DM: {
		da: { name: 'Dominica' },
		en: { name: 'Dominica' },
		de: { name: 'Dominica' },
		fo: { name: 'Dominica' },
		nb: { name: 'Dominica' },
		sv: { name: 'Dominica' }
	},
	EC: {
		da: { name: 'Ecuador' },
		en: { name: 'Ecuador' },
		de: { name: 'Ecuador' },
		fo: { name: 'Ekvador' },
		nb: { name: 'Ecuador' },
		sv: { name: 'Ecuador' }
	},
	EG: {
		da: { name: 'Egypten' },
		en: { name: 'Egypt' },
		de: { name: 'Ägypten' },
		fo: { name: 'Egyptaland' },
		nb: { name: 'Egypt' },
		sv: { name: 'Egypten' }
	},
	SV: {
		da: { name: 'El Salvador' },
		en: { name: 'El Salvador' },
		de: { name: 'El Salvador' },
		fo: { name: 'El Salvador' },
		nb: { name: 'El Salvador' },
		sv: { name: 'El Salvador' }
	},
	CI: {
		da: { name: 'Elfenbenskysten' },
		en: { name: 'Ivory Coast' },
		de: { name: 'Elfenbeinküste' },
		fo: { name: 'Elfenbenskysturin' },
		nb: { name: 'Elfenbenskysten' },
		sv: { name: 'Elfenbenskusten' }
	},
	ER: {
		da: { name: 'Eritrea' },
		en: { name: 'Eritrea' },
		de: { name: 'Eritrea' },
		fo: { name: 'Eritrea' },
		nb: { name: 'Eritrea' },
		sv: { name: 'Eritrea' }
	},
	EE: {
		da: { name: 'Estland' },
		en: { name: 'Estonia' },
		de: { name: 'Estland' },
		fo: { name: 'Estland' },
		nb: { name: 'Estland' },
		sv: { name: 'Estland' }
	},
	SZ: {
		da: { name: 'Eswatini' },
		en: { name: 'Eswatini' },
		de: { name: 'Eswatini' },
		fo: { name: 'Eswatini' },
		nb: { name: 'Eswatini' },
		sv: { name: 'Eswatini' }
	},
	ET: {
		da: { name: 'Etiopien' },
		en: { name: 'Ethiopia' },
		de: { name: 'Äthiopien' },
		fo: { name: 'Etiopia' },
		nb: { name: 'Etiopia' },
		sv: { name: 'Etiopien' }
	},
	FK: {
		da: { name: 'Falklandsøerne' },
		en: { name: 'Falkland Islands' },
		de: { name: 'Falklandinseln' },
		fo: { name: 'Falklandsoyggjar' },
		nb: { name: 'Falklandsøyene' },
		sv: { name: 'Falklandsöarna' }
	},
	FJ: {
		da: { name: 'Fiji' },
		en: { name: 'Fiji' },
		de: { name: 'Fidschi' },
		fo: { name: 'Fiji' },
		nb: { name: 'Fiji' },
		sv: { name: 'Fiji' }
	},
	PH: {
		da: { name: 'Filippinerne' },
		en: { name: 'Philippines' },
		de: { name: 'Philippinen' },
		fo: { name: 'Filippinoyggjar' },
		nb: { name: 'Filippinene' },
		sv: { name: 'Filippinerna' }
	},
	FI: {
		da: { name: 'Finland' },
		en: { name: 'Finland' },
		de: { name: 'Finnland' },
		fo: { name: 'Finnland' },
		nb: { name: 'Finland' },
		sv: { name: 'Finland' }
	},
	FR: {
		da: { name: 'Frankrig' },
		en: { name: 'France' },
		de: { name: 'Frankreich' },
		fo: { name: 'Frakland' },
		nb: { name: 'Frankrike' },
		sv: { name: 'Frankrike' }
	},
	GF: {
		da: { name: 'Fransk Guyana' },
		en: { name: 'French Guiana' },
		de: { name: 'Französisch-Guayana' },
		fo: { name: 'Fronsk Guiana' },
		nb: { name: 'Fransk Guyana' },
		sv: { name: 'Franska Guyana' }
	},
	PF: {
		da: { name: 'Fransk Polynesien' },
		en: { name: 'French Polynesia' },
		de: { name: 'Französisch-Polynesien' },
		fo: { name: 'Fronsk Polynesia' },
		nb: { name: 'Fransk Polynesia' },
		sv: { name: 'Franska Polynesien' }
	},
	FO: {
		da: { name: 'Færøerne' },
		en: { name: 'Faroe Islands' },
		de: { name: 'Färöer' },
		fo: { name: 'Føroyar' },
		nb: { name: 'Færøyene' },
		sv: { name: 'Färöarna' }
	},
	GA: {
		da: { name: 'Gabon' },
		en: { name: 'Gabon' },
		de: { name: 'Gabun' },
		fo: { name: 'Gabon' },
		nb: { name: 'Gabon' },
		sv: { name: 'Gabon' }
	},
	GM: {
		da: { name: 'Gambia' },
		en: { name: 'Gambia' },
		de: { name: 'Gambia' },
		fo: { name: 'Gambia' },
		nb: { name: 'Gambia' },
		sv: { name: 'Gambia' }
	},
	GE: {
		da: { name: 'Georgien' },
		en: { name: 'Georgia' },
		de: { name: 'Georgien' },
		fo: { name: 'Georgia' },
		nb: { name: 'Georgia' },
		sv: { name: 'Georgien' }
	},
	GH: {
		da: { name: 'Ghana' },
		en: { name: 'Ghana' },
		de: { name: 'Ghana' },
		fo: { name: 'Gana' },
		nb: { name: 'Ghana' },
		sv: { name: 'Ghana' }
	},
	GI: {
		da: { name: 'Gibraltar' },
		en: { name: 'Gibraltar' },
		de: { name: 'Gibraltar' },
		fo: { name: 'Gibraltar' },
		nb: { name: 'Gibraltar' },
		sv: { name: 'Gibraltar' }
	},
	GD: {
		da: { name: 'Grenada' },
		en: { name: 'Grenada' },
		de: { name: 'Grenada' },
		fo: { name: 'Grenada' },
		nb: { name: 'Grenada' },
		sv: { name: 'Grenada' }
	},
	GR: {
		da: { name: 'Grækenland' },
		en: { name: 'Greece' },
		de: { name: 'Griechenland' },
		fo: { name: 'Grikkaland' },
		nb: { name: 'Hellas' },
		sv: { name: 'Grekland' }
	},
	GL: {
		da: { name: 'Grønland' },
		en: { name: 'Greenland' },
		de: { name: 'Grönland' },
		fo: { name: 'Grønland' },
		nb: { name: 'Grønland' },
		sv: { name: 'Grönland' }
	},
	GP: {
		da: { name: 'Guadeloupe' },
		en: { name: 'Guadeloupe' },
		de: { name: 'Guadeloupe' },
		fo: { name: 'Guadeloupe' },
		nb: { name: 'Guadeloupe' },
		sv: { name: 'Guadeloupe' }
	},
	GU: {
		da: { name: 'Guam' },
		en: { name: 'Guam' },
		de: { name: 'Guam' },
		fo: { name: 'Guam' },
		nb: { name: 'Guam' },
		sv: { name: 'Guam' }
	},
	GT: {
		da: { name: 'Guatemala' },
		en: { name: 'Guatemala' },
		de: { name: 'Guatemala' },
		fo: { name: 'Guatemala' },
		nb: { name: 'Guatemala' },
		sv: { name: 'Guatemala' }
	},
	GG: {
		da: { name: 'Guernsey' },
		en: { name: 'Guernsey' },
		de: { name: 'Guernsey' },
		fo: { name: 'Guernsey' },
		nb: { name: 'Guernsey' },
		sv: { name: 'Guernsey' }
	},
	GN: {
		da: { name: 'Guinea' },
		en: { name: 'Guinea' },
		de: { name: 'Guinea' },
		fo: { name: 'Guinea' },
		nb: { name: 'Guinea' },
		sv: { name: 'Guinea' }
	},
	GW: {
		da: { name: 'Guinea-Bissau' },
		en: { name: 'Guinea-Bissau' },
		de: { name: 'Guinea-Bissau' },
		fo: { name: 'Guinea-Bissau' },
		nb: { name: 'Guinea-Bissau' },
		sv: { name: 'Guinea-Bissau' }
	},
	GY: {
		da: { name: 'Guyana' },
		en: { name: 'Guyana' },
		de: { name: 'Guyana' },
		fo: { name: 'Guyana' },
		nb: { name: 'Guyana' },
		sv: { name: 'Guyana' }
	},
	HT: {
		da: { name: 'Haiti' },
		en: { name: 'Haiti' },
		de: { name: 'Haiti' },
		fo: { name: 'Haiti' },
		nb: { name: 'Haiti' },
		sv: { name: 'Haiti' }
	},
	HM: {
		da: { name: 'Heard Island og McDonald Islands' },
		en: { name: 'Heard Island and McDonald Islands' },
		de: { name: 'Heard und McDonaldinseln' },
		fo: { name: 'Heard og McDonaldoyggjar' },
		nb: { name: 'Heard- og McDonaldøyene' },
		sv: { name: 'Heard- och McDonaldöarna' }
	},
	NL: {
		da: { name: 'Holland' },
		en: { name: 'Netherlands' },
		de: { name: 'Niederlande' },
		fo: { name: 'Niðurlond' },
		nb: { name: 'Nederland' },
		sv: { name: 'Nederländerna' }
	},
	HN: {
		da: { name: 'Honduras' },
		en: { name: 'Honduras' },
		de: { name: 'Honduras' },
		fo: { name: 'Honduras' },
		nb: { name: 'Honduras' },
		sv: { name: 'Honduras' }
	},
	BY: {
		da: { name: 'Hviderusland' },
		en: { name: 'Belarus' },
		de: { name: 'Weißrussland' },
		fo: { name: 'Hvítarussland' },
		nb: { name: 'Hviterussland' },
		sv: { name: 'Vitryssland' }
	},
	IN: {
		da: { name: 'Indien' },
		en: { name: 'India' },
		de: { name: 'Indien' },
		fo: { name: 'India' },
		nb: { name: 'India' },
		sv: { name: 'Indien' }
	},
	ID: {
		da: { name: 'Indonesien' },
		en: { name: 'Indonesia' },
		de: { name: 'Indonesien' },
		fo: { name: 'Indonesia' },
		nb: { name: 'Indonesia' },
		sv: { name: 'Indonesien' }
	},
	IQ: {
		da: { name: 'Irak' },
		en: { name: 'Iraq' },
		de: { name: 'Irak' },
		fo: { name: 'Irak' },
		nb: { name: 'Irak' },
		sv: { name: 'Irak' }
	},
	IR: {
		da: { name: 'Iran' },
		en: { name: 'Iran' },
		de: { name: 'Iran' },
		fo: { name: 'Iran' },
		nb: { name: 'Iran' },
		sv: { name: 'Iran' }
	},
	IE: {
		da: { name: 'Irland' },
		en: { name: 'Ireland' },
		de: { name: 'Irland' },
		fo: { name: 'Írland' },
		nb: { name: 'Irland' },
		sv: { name: 'Irland' }
	},
	IS: {
		da: { name: 'Island' },
		en: { name: 'Iceland' },
		de: { name: 'Island' },
		fo: { name: 'Ísland' },
		nb: { name: 'Island' },
		sv: { name: 'Island' }
	},
	IM: {
		da: { name: 'Isle of Man' },
		en: { name: 'Isle of Man' },
		de: { name: 'Isle of Man' },
		fo: { name: 'Isle of Man' },
		nb: { name: 'Isle of Man' },
		sv: { name: 'Isle of Man' }
	},
	IL: {
		da: { name: 'Israel' },
		en: { name: 'Israel' },
		de: { name: 'Israel' },
		fo: { name: 'Ísrael' },
		nb: { name: 'Israel' },
		sv: { name: 'Israel' }
	},
	IT: {
		da: { name: 'Italien' },
		en: { name: 'Italy' },
		de: { name: 'Italien' },
		fo: { name: 'Italia' },
		nb: { name: 'Italia' },
		sv: { name: 'Italien' }
	},
	JM: {
		da: { name: 'Jamaica' },
		en: { name: 'Jamaica' },
		de: { name: 'Jamaika' },
		fo: { name: 'Jamaika' },
		nb: { name: 'Jamaica' },
		sv: { name: 'Jamaica' }
	},
	JP: {
		da: { name: 'Japan' },
		en: { name: 'Japan' },
		de: { name: 'Japan' },
		fo: { name: 'Japan' },
		nb: { name: 'Japan' },
		sv: { name: 'Japan' }
	},
	JE: {
		da: { name: 'Jersey' },
		en: { name: 'Jersey' },
		de: { name: 'Jersey' },
		fo: { name: 'Jersey' },
		nb: { name: 'Jersey' },
		sv: { name: 'Jersey' }
	},
	JO: {
		da: { name: 'Jordan' },
		en: { name: 'Jordan' },
		de: { name: 'Jordanien' },
		fo: { name: 'Jordan' },
		nb: { name: 'Jordan' },
		sv: { name: 'Jordanien' }
	},
	CX: {
		da: { name: 'Juleøen' },
		en: { name: 'Christmas Island' },
		de: { name: 'Weihnachtsinsel' },
		fo: { name: 'Jólaoyggin' },
		nb: { name: 'Christmasøya' },
		sv: { name: 'Julön' }
	},
	CV: {
		da: { name: 'Kap Verde' },
		en: { name: 'Cape Verde' },
		de: { name: 'Kap Verde' },
		fo: { name: 'Kap Verde' },
		nb: { name: 'Kapp Verde' },
		sv: { name: 'Kap Verde' }
	},
	KZ: {
		da: { name: 'Kasakhstan' },
		en: { name: 'Kazakhstan' },
		de: { name: 'Kasachstan' },
		fo: { name: 'Kasakstan' },
		nb: { name: 'Kasakhstan' },
		sv: { name: 'Kazakstan' }
	},
	KE: {
		da: { name: 'Kenya' },
		en: { name: 'Kenya' },
		de: { name: 'Kenia' },
		fo: { name: 'Kenja' },
		nb: { name: 'Kenya' },
		sv: { name: 'Kenya' }
	},
	CN: {
		da: { name: 'Kina' },
		en: { name: 'China' },
		de: { name: 'China' },
		fo: { name: 'Kina' },
		nb: { name: 'Kina' },
		sv: { name: 'Kina' }
	},
	KG: {
		da: { name: 'Kirgisistan' },
		en: { name: 'Kyrgyzstan' },
		de: { name: 'Kirgisistan' },
		fo: { name: 'Kirgisia' },
		nb: { name: 'Kirgisistan' },
		sv: { name: 'Kirgizistan' }
	},
	KI: {
		da: { name: 'Kiribati' },
		en: { name: 'Kiribati' },
		de: { name: 'Kiribati' },
		fo: { name: 'Kiribati' },
		nb: { name: 'Kiribati' },
		sv: { name: 'Kiribati' }
	},
	HR: {
		da: { name: 'Kroatien' },
		en: { name: 'Croatia' },
		de: { name: 'Kroatien' },
		fo: { name: 'Kroatia' },
		nb: { name: 'Kroatia' },
		sv: { name: 'Kroatien' }
	},
	KW: {
		da: { name: 'Kuwait' },
		en: { name: 'Kuwait' },
		de: { name: 'Kuwait' },
		fo: { name: 'Kuwait' },
		nb: { name: 'Kuwait' },
		sv: { name: 'Kuwait' }
	},
	LA: {
		da: { name: 'Laos' },
		en: { name: 'Laos' },
		de: { name: 'Laos' },
		fo: { name: 'Laos' },
		nb: { name: 'Laos' },
		sv: { name: 'Laos' }
	},
	LS: {
		da: { name: 'Lesotho' },
		en: { name: 'Lesotho' },
		de: { name: 'Lesotho' },
		fo: { name: 'Lesotho' },
		nb: { name: 'Lesotho' },
		sv: { name: 'Lesotho' }
	},
	LV: {
		da: { name: 'Letland' },
		en: { name: 'Latvia' },
		de: { name: 'Lettland' },
		fo: { name: 'Latvia' },
		nb: { name: 'Latvia' },
		sv: { name: 'Lettland' }
	},
	LB: {
		da: { name: 'Libanon' },
		en: { name: 'Lebanon' },
		de: { name: 'Libanon' },
		fo: { name: 'Libanon' },
		nb: { name: 'Libanon' },
		sv: { name: 'Libanon' }
	},
	LR: {
		da: { name: 'Liberia' },
		en: { name: 'Liberia' },
		de: { name: 'Liberia' },
		fo: { name: 'Liberia' },
		nb: { name: 'Liberia' },
		sv: { name: 'Liberia' }
	},
	LY: {
		da: { name: 'Libyen' },
		en: { name: 'Libya' },
		de: { name: 'Libyen' },
		fo: { name: 'Libya' },
		nb: { name: 'Libya' },
		sv: { name: 'Libyen' }
	},
	LI: {
		da: { name: 'Liechtenstein' },
		en: { name: 'Liechtenstein' },
		de: { name: 'Liechtenstein' },
		fo: { name: 'Liechtenstein' },
		nb: { name: 'Liechtenstein' },
		sv: { name: 'Liechtenstein' }
	},
	LT: {
		da: { name: 'Litauen' },
		en: { name: 'Lithuania' },
		de: { name: 'Litauen' },
		fo: { name: 'Litauen' },
		nb: { name: 'Litauen' },
		sv: { name: 'Litauen' }
	},
	LU: {
		da: { name: 'Luxembourg' },
		en: { name: 'Luxembourg' },
		de: { name: 'Luxemburg' },
		fo: { name: 'Lúxemburg' },
		nb: { name: 'Luxembourg' },
		sv: { name: 'Luxemburg' }
	},
	MG: {
		da: { name: 'Madagaskar' },
		en: { name: 'Madagascar' },
		de: { name: 'Madagaskar' },
		fo: { name: 'Madagaskar' },
		nb: { name: 'Madagaskar' },
		sv: { name: 'Madagaskar' }
	},
	MW: {
		da: { name: 'Malawi' },
		en: { name: 'Malawi' },
		de: { name: 'Malawi' },
		fo: { name: 'Malawi' },
		nb: { name: 'Malawi' },
		sv: { name: 'Malawi' }
	},
	MY: {
		da: { name: 'Malaysia' },
		en: { name: 'Malaysia' },
		de: { name: 'Malaysia' },
		fo: { name: 'Malaisia' },
		nb: { name: 'Malaysia' },
		sv: { name: 'Malaysia' }
	},
	MV: {
		da: { name: 'Maldiverne' },
		en: { name: 'Maldives' },
		de: { name: 'Malediven' },
		fo: { name: 'Maldivoyggjar' },
		nb: { name: 'Maldivene' },
		sv: { name: 'Maldiverna' }
	},
	ML: {
		da: { name: 'Mali' },
		en: { name: 'Mali' },
		de: { name: 'Mali' },
		fo: { name: 'Mali' },
		nb: { name: 'Mali' },
		sv: { name: 'Mali' }
	},
	MT: {
		da: { name: 'Malta' },
		en: { name: 'Malta' },
		de: { name: 'Malta' },
		fo: { name: 'Malta' },
		nb: { name: 'Malta' },
		sv: { name: 'Malta' }
	},
	MA: {
		da: { name: 'Marokko' },
		en: { name: 'Morocco' },
		de: { name: 'Marokko' },
		fo: { name: 'Marokko' },
		nb: { name: 'Marokko' },
		sv: { name: 'Marocko' }
	},
	MH: {
		da: { name: 'Marshalløerne' },
		en: { name: 'Marshall Islands' },
		de: { name: 'Marshallinseln' },
		fo: { name: 'Marshalloyggjar' },
		nb: { name: 'Marshalløyene' },
		sv: { name: 'Marshallöarna' }
	},
	MQ: {
		da: { name: 'Martinique' },
		en: { name: 'Martinique' },
		de: { name: 'Martinique' },
		fo: { name: 'Martinique' },
		nb: { name: 'Martinique' },
		sv: { name: 'Martinique' }
	},
	MR: {
		da: { name: 'Mauretanien' },
		en: { name: 'Mauritania' },
		de: { name: 'Mauretanien' },
		fo: { name: 'Móritania' },
		nb: { name: 'Mauritania' },
		sv: { name: 'Mauretanien' }
	},
	MU: {
		da: { name: 'Mauritius' },
		en: { name: 'Mauritius' },
		de: { name: 'Mauritius' },
		fo: { name: 'Mauritius' },
		nb: { name: 'Mauritius' },
		sv: { name: 'Mauritius' }
	},
	YT: {
		da: { name: 'Mayotte' },
		en: { name: 'Mayotte' },
		de: { name: 'Mayotte' },
		fo: { name: 'Mayotte' },
		nb: { name: 'Mayotte' },
		sv: { name: 'Mayotte' }
	},
	MX: {
		da: { name: 'Mexico' },
		en: { name: 'Mexico' },
		de: { name: 'Mexiko' },
		fo: { name: 'Meksiko' },
		nb: { name: 'Mexico' },
		sv: { name: 'Mexiko' }
	},
	FM: {
		da: { name: 'Mikronesien' },
		en: { name: 'Micronesia' },
		de: { name: 'Mikronesien' },
		fo: { name: 'Mikronesia' },
		nb: { name: 'Mikronesia' },
		sv: { name: 'Mikronesien' }
	},
	MD: {
		da: { name: 'Moldova' },
		en: { name: 'Moldova' },
		de: { name: 'Moldawien' },
		fo: { name: 'Moldova' },
		nb: { name: 'Moldova' },
		sv: { name: 'Moldavien' }
	},
	MC: {
		da: { name: 'Monaco' },
		en: { name: 'Monaco' },
		de: { name: 'Monaco' },
		fo: { name: 'Monako' },
		nb: { name: 'Monaco' },
		sv: { name: 'Monaco' }
	},
	MN: {
		da: { name: 'Mongoliet' },
		en: { name: 'Mongolia' },
		de: { name: 'Mongolei' },
		fo: { name: 'Mongolia' },
		nb: { name: 'Mongolia' },
		sv: { name: 'Mongoliet' }
	},
	ME: {
		da: { name: 'Montenegro' },
		en: { name: 'Montenegro' },
		de: { name: 'Montenegro' },
		fo: { name: 'Montenegro' },
		nb: { name: 'Montenegro' },
		sv: { name: 'Montenegro' }
	},
	MS: {
		da: { name: 'Montserrat' },
		en: { name: 'Montserrat' },
		de: { name: 'Montserrat' },
		fo: { name: 'Montserrat' },
		nb: { name: 'Montserrat' },
		sv: { name: 'Montserrat' }
	},
	MZ: {
		da: { name: 'Mozambique' },
		en: { name: 'Mozambique' },
		de: { name: 'Mosambik' },
		fo: { name: 'Mosambik' },
		nb: { name: 'Mosambik' },
		sv: { name: 'Moçambique' }
	},
	MM: {
		da: { name: 'Myanmar (Burma)' },
		en: { name: 'Myanmar (Burma)' },
		de: { name: 'Myanmar (Birma)' },
		fo: { name: 'Myanmar (Burma)' },
		nb: { name: 'Myanmar (Burma)' },
		sv: { name: 'Myanmar (Burma)' }
	},
	NA: {
		da: { name: 'Namibia' },
		en: { name: 'Namibia' },
		de: { name: 'Namibia' },
		fo: { name: 'Namibia' },
		nb: { name: 'Namibia' },
		sv: { name: 'Namibia' }
	},
	NR: {
		da: { name: 'Nauru' },
		en: { name: 'Nauru' },
		de: { name: 'Nauru' },
		fo: { name: 'Nauru' },
		nb: { name: 'Nauru' },
		sv: { name: 'Nauru' }
	},
	NP: {
		da: { name: 'Nepal' },
		en: { name: 'Nepal' },
		de: { name: 'Nepal' },
		fo: { name: 'Nepal' },
		nb: { name: 'Nepal' },
		sv: { name: 'Nepal' }
	},
	NZ: {
		da: { name: 'New Zealand' },
		en: { name: 'New Zealand' },
		de: { name: 'Neuseeland' },
		fo: { name: 'Ný Sæland' },
		nb: { name: 'New Zealand' },
		sv: { name: 'Nya Zeeland' }
	},
	NI: {
		da: { name: 'Nicaragua' },
		en: { name: 'Nicaragua' },
		de: { name: 'Nicaragua' },
		fo: { name: 'Nikaragua' },
		nb: { name: 'Nicaragua' },
		sv: { name: 'Nicaragua' }
	},
	NE: {
		da: { name: 'Niger' },
		en: { name: 'Niger' },
		de: { name: 'Niger' },
		fo: { name: 'Niger' },
		nb: { name: 'Niger' },
		sv: { name: 'Niger' }
	},
	NG: {
		da: { name: 'Nigeria' },
		en: { name: 'Nigeria' },
		de: { name: 'Nigeria' },
		fo: { name: 'Nigeria' },
		nb: { name: 'Nigeria' },
		sv: { name: 'Nigeria' }
	},
	NU: {
		da: { name: 'Niue' },
		en: { name: 'Niue' },
		de: { name: 'Niue' },
		fo: { name: 'Niue' },
		nb: { name: 'Niue' },
		sv: { name: 'Niue' }
	},
	KP: {
		da: { name: 'Nordkorea' },
		en: { name: 'North Korea' },
		de: { name: 'Nordkorea' },
		fo: { name: 'Norðurkorea' },
		nb: { name: 'Nord-Korea' },
		sv: { name: 'Nordkorea' }
	},
	MK: {
		da: { name: 'Nordmakedonien' },
		en: { name: 'North Macedonia' },
		de: { name: 'Nordmazedonien' },
		fo: { name: 'Norðurmakedónia' },
		nb: { name: 'Nord-Makedonia' },
		sv: { name: 'Nordmakedonien' }
	},
	MP: {
		da: { name: 'Nordmarianerne' },
		en: { name: 'Northern Mariana Islands' },
		de: { name: 'Nördliche Marianen' },
		fo: { name: 'Norðaru Mariuoyggjar' },
		nb: { name: 'Nord-Marianene' },
		sv: { name: 'Nordmarianerna' }
	},
	NF: {
		da: { name: 'Norfolk Island' },
		en: { name: 'Norfolk Island' },
		de: { name: 'Norfolkinsel' },
		fo: { name: 'Norfolksoyggin' },
		nb: { name: 'Norfolkøya' },
		sv: { name: 'Norfolkön' }
	},
	NO: {
		da: { name: 'Norge' },
		en: { name: 'Norway' },
		de: { name: 'Norwegen' },
		fo: { name: 'Noreg' },
		nb: { name: 'Norge' },
		sv: { name: 'Norge' }
	},
	NC: {
		da: { name: 'Ny Kaledonien' },
		en: { name: 'New Caledonia' },
		de: { name: 'Neukaledonien' },
		fo: { name: 'Nýkaledónia' },
		nb: { name: 'Ny-Caledonia' },
		sv: { name: 'Nya Kaledonien' }
	},
	OM: {
		da: { name: 'Oman' },
		en: { name: 'Oman' },
		de: { name: 'Oman' },
		fo: { name: 'Oman' },
		nb: { name: 'Oman' },
		sv: { name: 'Oman' }
	},
	PK: {
		da: { name: 'Pakistan' },
		en: { name: 'Pakistan' },
		de: { name: 'Pakistan' },
		fo: { name: 'Pakistan' },
		nb: { name: 'Pakistan' },
		sv: { name: 'Pakistan' }
	},
	PW: {
		da: { name: 'Palau' },
		en: { name: 'Palau' },
		de: { name: 'Palau' },
		fo: { name: 'Palau' },
		nb: { name: 'Palau' },
		sv: { name: 'Palau' }
	},
	PA: {
		da: { name: 'Panama' },
		en: { name: 'Panama' },
		de: { name: 'Panama' },
		fo: { name: 'Panama' },
		nb: { name: 'Panama' },
		sv: { name: 'Panama' }
	},
	PG: {
		da: { name: 'Papua Ny Guinea' },
		en: { name: 'Papua New Guinea' },
		de: { name: 'Papua-Neuguinea' },
		fo: { name: 'Papua Ný Guinea' },
		nb: { name: 'Papua Ny-Guinea' },
		sv: { name: 'Papua Nya Guinea' }
	},
	PY: {
		da: { name: 'Paraguay' },
		en: { name: 'Paraguay' },
		de: { name: 'Paraguay' },
		fo: { name: 'Paraguay' },
		nb: { name: 'Paraguay' },
		sv: { name: 'Paraguay' }
	},
	PE: {
		da: { name: 'Peru' },
		en: { name: 'Peru' },
		de: { name: 'Peru' },
		fo: { name: 'Peru' },
		nb: { name: 'Peru' },
		sv: { name: 'Peru' }
	},
	PN: {
		da: { name: 'Pitcairn' },
		en: { name: 'Pitcairn' },
		de: { name: 'Pitcairn' },
		fo: { name: 'Pitcairn' },
		nb: { name: 'Pitcairn' },
		sv: { name: 'Pitcairn' }
	},
	PL: {
		da: { name: 'Polen' },
		en: { name: 'Poland' },
		de: { name: 'Polen' },
		fo: { name: 'Pólland' },
		nb: { name: 'Polen' },
		sv: { name: 'Polen' }
	},
	PT: {
		da: { name: 'Portugal' },
		en: { name: 'Portugal' },
		de: { name: 'Portugal' },
		fo: { name: 'Portugal' },
		nb: { name: 'Portugal' },
		sv: { name: 'Portugal' }
	},
	PR: {
		da: { name: 'Puerto Rico' },
		en: { name: 'Puerto Rico' },
		de: { name: 'Puerto Rico' },
		fo: { name: 'Puerto Rico' },
		nb: { name: 'Puerto Rico' },
		sv: { name: 'Puerto Rico' }
	},
	QA: {
		da: { name: 'Qatar' },
		en: { name: 'Qatar' },
		de: { name: 'Katar' },
		fo: { name: 'Katar' },
		nb: { name: 'Qatar' },
		sv: { name: 'Qatar' }
	},
	RE: {
		da: { name: 'Réunion' },
		en: { name: 'Réunion' },
		de: { name: 'Réunion' },
		fo: { name: 'Réunion' },
		nb: { name: 'Réunion' },
		sv: { name: 'Réunion' }
	},
	RO: {
		da: { name: 'Rumænien' },
		en: { name: 'Romania' },
		de: { name: 'Rumänien' },
		fo: { name: 'Rumenia' },
		nb: { name: 'Romania' },
		sv: { name: 'Rumänien' }
	},
	RU: {
		da: { name: 'Rusland' },
		en: { name: 'Russia' },
		de: { name: 'Russland' },
		fo: { name: 'Russland' },
		nb: { name: 'Russland' },
		sv: { name: 'Ryssland' }
	},
	RW: {
		da: { name: 'Rwanda' },
		en: { name: 'Rwanda' },
		de: { name: 'Ruanda' },
		fo: { name: 'Ruanda' },
		nb: { name: 'Rwanda' },
		sv: { name: 'Rwanda' }
	},
	BL: {
		da: { name: 'Saint Barthélemy' },
		en: { name: 'Saint Barthélemy' },
		de: { name: 'Saint-Barthélemy' },
		fo: { name: 'Saint Barthélemy' },
		nb: { name: 'Saint Barthélemy' },
		sv: { name: 'Saint Barthélemy' }
	},
	KN: {
		da: { name: 'Saint Kitts og Nevis' },
		en: { name: 'Saint Kitts and Nevis' },
		de: { name: 'St\. Kitts und Nevis' },
		fo: { name: 'Saint Kitts og Nevis' },
		nb: { name: 'Saint Kitts og Nevis' },
		sv: { name: 'Saint Kitts och Nevis' }
	},
	LC: {
		da: { name: 'Saint Lucia' },
		en: { name: 'Saint Lucia' },
		de: { name: 'St\. Lucia' },
		fo: { name: 'Saint Lusia' },
		nb: { name: 'Saint Lucia' },
		sv: { name: 'Saint Lucia' }
	},
	MF: {
		da: { name: 'Saint Martin' },
		en: { name: 'Saint Martin' },
		de: { name: 'Saint-Martin' },
		fo: { name: 'Saint Martin' },
		nb: { name: 'Saint Martin' },
		sv: { name: 'Saint Martin' }
	},
	PM: {
		da: { name: 'Saint Pierre og Miquelon' },
		en: { name: 'Saint Pierre and Miquelon' },
		de: { name: 'Saint-Pierre und Miquelon' },
		fo: { name: 'Saint Pierre og Miquelon' },
		nb: { name: 'Saint Pierre og Miquelon' },
		sv: { name: 'Saint Pierre och Miquelon' }
	},
	VC: {
		da: { name: 'Saint Vincent og Grenadinerne' },
		en: { name: 'Saint Vincent and the Grenadines' },
		de: { name: 'Saint Vincent und die Grenadinen' },
		fo: { name: 'Saint Vinsent og Grenadinoyggjar' },
		nb: { name: 'Saint Vincent og Grenadinene' },
		sv: { name: 'Saint Vincent och Grenadinerna' }
	},
	SB: {
		da: { name: 'Salomonøerne' },
		en: { name: 'Solomon Islands' },
		de: { name: 'Salomonen' },
		fo: { name: 'Salomonoyggjar' },
		nb: { name: 'Salomonøyene' },
		sv: { name: 'Salomonöarna' }
	},
	WS: {
		da: { name: 'Samoa' },
		en: { name: 'Samoa' },
		de: { name: 'Samoa' },
		fo: { name: 'Samoa' },
		nb: { name: 'Samoa' },
		sv: { name: 'Samoa' }
	},
	SM: {
		da: { name: 'San Marino' },
		en: { name: 'San Marino' },
		de: { name: 'San Marino' },
		fo: { name: 'San Marino' },
		nb: { name: 'San Marino' },
		sv: { name: 'San Marino' }
	},
	ST: {
		da: { name: 'São Tomé og Príncipe' },
		en: { name: 'São Tomé and Príncipe' },
		de: { name: 'São Tomé und Príncipe' },
		fo: { name: 'Sao Tome og Prinsipi' },
		nb: { name: 'São Tomé og Príncipe' },
		sv: { name: 'São Tomé och Príncipe' }
	},
	HK: {
		da: { name: 'SAR Hongkong' },
		en: { name: 'Hong Kong SAR' },
		de: { name: 'Sonderverwaltungszone Hongkong' },
		fo: { name: 'Hongkong SAR' },
		nb: { name: 'Hongkong SAR' },
		sv: { name: 'Hongkong SAR' }
	},
	MO: {
		da: { name: 'SAR Macao' },
		en: { name: 'Macau SAR' },
		de: { name: 'Sonderverwaltungszone Macao' },
		fo: { name: 'Makao SAR' },
		nb: { name: 'Macao SAR' },
		sv: { name: 'Macao SAR' }
	},
	SA: {
		da: { name: 'Saudi-Arabien' },
		en: { name: 'Saudi Arabia' },
		de: { name: 'Saudi-Arabien' },
		fo: { name: 'Saudiarabia' },
		nb: { name: 'Saudi-Arabia' },
		sv: { name: 'Saudiarabien' }
	},
	CH: {
		da: { name: 'Schweiz' },
		en: { name: 'Switzerland' },
		de: { name: 'Schweiz' },
		fo: { name: 'Sveis' },
		nb: { name: 'Sveits' },
		sv: { name: 'Schweiz' }
	},
	SN: {
		da: { name: 'Senegal' },
		en: { name: 'Senegal' },
		de: { name: 'Senegal' },
		fo: { name: 'Senegal' },
		nb: { name: 'Senegal' },
		sv: { name: 'Senegal' }
	},
	RS: {
		da: { name: 'Serbien' },
		en: { name: 'Serbia' },
		de: { name: 'Serbien' },
		fo: { name: 'Serbia' },
		nb: { name: 'Serbia' },
		sv: { name: 'Serbien' }
	},
	SC: {
		da: { name: 'Seychellerne' },
		en: { name: 'Seychelles' },
		de: { name: 'Seychellen' },
		fo: { name: 'Seyskelloyggjar' },
		nb: { name: 'Seychellene' },
		sv: { name: 'Seychellerna' }
	},
	SL: {
		da: { name: 'Sierra Leone' },
		en: { name: 'Sierra Leone' },
		de: { name: 'Sierra Leone' },
		fo: { name: 'Sierra Leone' },
		nb: { name: 'Sierra Leone' },
		sv: { name: 'Sierra Leone' }
	},
	SG: {
		da: { name: 'Singapore' },
		en: { name: 'Singapore' },
		de: { name: 'Singapur' },
		fo: { name: 'Singapor' },
		nb: { name: 'Singapore' },
		sv: { name: 'Singapore' }
	},
	SX: {
		da: { name: 'Sint Maarten' },
		en: { name: 'Sint Maarten' },
		de: { name: 'Sint Maarten' },
		fo: { name: 'Sint Maarten' },
		nb: { name: 'Sint Maarten' },
		sv: { name: 'Sint Maarten' }
	},
	SK: {
		da: { name: 'Slovakiet' },
		en: { name: 'Slovakia' },
		de: { name: 'Slowakei' },
		fo: { name: 'Slovakia' },
		nb: { name: 'Slovakia' },
		sv: { name: 'Slovakien' }
	},
	SI: {
		da: { name: 'Slovenien' },
		en: { name: 'Slovenia' },
		de: { name: 'Slowenien' },
		fo: { name: 'Slovenia' },
		nb: { name: 'Slovenia' },
		sv: { name: 'Slovenien' }
	},
	SO: {
		da: { name: 'Somalia' },
		en: { name: 'Somalia' },
		de: { name: 'Somalia' },
		fo: { name: 'Somalia' },
		nb: { name: 'Somalia' },
		sv: { name: 'Somalia' }
	},
	GS: {
		da: { name: 'South Georgia og De Sydlige Sandwichøer' },
		en: { name: 'South Georgia and the South Sandwich Islands' },
		de: { name: 'Südgeorgien und die Südlichen Sandwichinseln' },
		fo: { name: 'Suðurgeorgia og Suðursandwichoyggjar' },
		nb: { name: 'Sør-Georgia og Sør-Sandwichøyene' },
		sv: { name: 'Sydgeorgien och Sydsandwichöarna' }
	},
	ES: {
		da: { name: 'Spanien' },
		en: { name: 'Spain' },
		de: { name: 'Spanien' },
		fo: { name: 'Spania' },
		nb: { name: 'Spania' },
		sv: { name: 'Spanien' }
	},
	LK: {
		da: { name: 'Sri Lanka' },
		en: { name: 'Sri Lanka' },
		de: { name: 'Sri Lanka' },
		fo: { name: 'Sri Lanka' },
		nb: { name: 'Sri Lanka' },
		sv: { name: 'Sri Lanka' }
	},
	SH: {
		da: { name: 'St. Helena' },
		en: { name: 'Saint Helena' },
		de: { name: 'St\. Helena' },
		fo: { name: 'Saint Helena' },
		nb: { name: 'Saint Helena' },
		sv: { name: 'Saint Helena' }
	},
	GB: {
		da: { name: 'Storbritannien' },
		en: { name: 'United Kingdom' },
		de: { name: 'Grossbritannien' },
		fo: { name: 'Stórabretland' },
		nb: { name: 'Storbritannia' },
		sv: { name: 'Storbritannien' }
	},
	SD: {
		da: { name: 'Sudan' },
		en: { name: 'Sudan' },
		de: { name: 'Sudan' },
		fo: { name: 'Sudan' },
		nb: { name: 'Sudan' },
		sv: { name: 'Sudan' }
	},
	SR: {
		da: { name: 'Surinam' },
		en: { name: 'Suriname' },
		de: { name: 'Surinam' },
		fo: { name: 'Surinam' },
		nb: { name: 'Surinam' },
		sv: { name: 'Surinam' }
	},
	SJ: {
		da: { name: 'Svalbard og Jan Mayen' },
		en: { name: 'Svalbard and Jan Mayen' },
		de: { name: 'Svalbard und Jan Mayen' },
		fo: { name: 'Svalbard og Jan Mayen' },
		nb: { name: 'Svalbard og Jan Mayen' },
		sv: { name: 'Svalbard och Jan Mayen' }
	},
	SE: {
		da: { name: 'Sverige' },
		en: { name: 'Sweden' },
		de: { name: 'Schweden' },
		fo: { name: 'Svøríki' },
		nb: { name: 'Sverige' },
		sv: { name: 'Sverige' }
	},
	ZA: {
		da: { name: 'Sydafrika' },
		en: { name: 'South Africa' },
		de: { name: 'Südafrika' },
		fo: { name: 'Suðurafrika' },
		nb: { name: 'Sør-Afrika' },
		sv: { name: 'Sydafrika' }
	},
	KR: {
		da: { name: 'Sydkorea' },
		en: { name: 'South Korea' },
		de: { name: 'Südkorea' },
		fo: { name: 'Suðurkorea' },
		nb: { name: 'Sør-Korea' },
		sv: { name: 'Sydkorea' }
	},
	SS: {
		da: { name: 'Sydsudan' },
		en: { name: 'South Sudan' },
		de: { name: 'Südsudan' },
		fo: { name: 'Suðursudan' },
		nb: { name: 'Sør-Sudan' },
		sv: { name: 'Sydsudan' }
	},
	SY: {
		da: { name: 'Syrien' },
		en: { name: 'Syria' },
		de: { name: 'Syrien' },
		fo: { name: 'Sýria' },
		nb: { name: 'Syria' },
		sv: { name: 'Syrien' }
	},
	TJ: {
		da: { name: 'Tadsjikistan' },
		en: { name: 'Tajikistan' },
		de: { name: 'Tadschikistan' },
		fo: { name: 'Tadsjikistan' },
		nb: { name: 'Tadsjikistan' },
		sv: { name: 'Tadzjikistan' }
	},
	TW: {
		da: { name: 'Taiwan' },
		en: { name: 'Taiwan' },
		de: { name: 'Taiwan' },
		fo: { name: 'Taiwan' },
		nb: { name: 'Taiwan' },
		sv: { name: 'Taiwan' }
	},
	TZ: {
		da: { name: 'Tanzania' },
		en: { name: 'Tanzania' },
		de: { name: 'Tansania' },
		fo: { name: 'Tansania' },
		nb: { name: 'Tanzania' },
		sv: { name: 'Tanzania' }
	},
	TD: {
		da: { name: 'Tchad' },
		en: { name: 'Chad' },
		de: { name: 'Tschad' },
		fo: { name: 'Kjad' },
		nb: { name: 'Tchad' },
		sv: { name: 'Tchad' }
	},
	TH: {
		da: { name: 'Thailand' },
		en: { name: 'Thailand' },
		de: { name: 'Thailand' },
		fo: { name: 'Thailand' },
		nb: { name: 'Thailand' },
		sv: { name: 'Thailand' }
	},
	TL: {
		da: { name: 'Timor-Leste' },
		en: { name: 'Timor-Leste' },
		de: { name: 'Osttimor' },
		fo: { name: 'Eysturtimor' },
		nb: { name: 'Øst-Timor' },
		sv: { name: 'Östtimor' }
	},
	CZ: {
		da: { name: 'Tjekkiet' },
		en: { name: 'Czechia' },
		de: { name: 'Tschechien' },
		fo: { name: 'Kekkia' },
		nb: { name: 'Tsjekkia' },
		sv: { name: 'Tjeckien' }
	},
	TG: {
		da: { name: 'Togo' },
		en: { name: 'Togo' },
		de: { name: 'Togo' },
		fo: { name: 'Togo' },
		nb: { name: 'Togo' },
		sv: { name: 'Togo' }
	},
	TK: {
		da: { name: 'Tokelau' },
		en: { name: 'Tokelau' },
		de: { name: 'Tokelau' },
		fo: { name: 'Tokelau' },
		nb: { name: 'Tokelau' },
		sv: { name: 'Tokelau' }
	},
	TO: {
		da: { name: 'Tonga' },
		en: { name: 'Tonga' },
		de: { name: 'Tonga' },
		fo: { name: 'Tonga' },
		nb: { name: 'Tonga' },
		sv: { name: 'Tonga' }
	},
	TT: {
		da: { name: 'Trinidad og Tobago' },
		en: { name: 'Trinidad and Tobago' },
		de: { name: 'Trinidad und Tobago' },
		fo: { name: 'Trinidad og Tobago' },
		nb: { name: 'Trinidad og Tobago' },
		sv: { name: 'Trinidad och Tobago' }
	},
	TN: {
		da: { name: 'Tunesien' },
		en: { name: 'Tunisia' },
		de: { name: 'Tunesien' },
		fo: { name: 'Tunesia' },
		nb: { name: 'Tunisia' },
		sv: { name: 'Tunisien' }
	},
	TM: {
		da: { name: 'Turkmenistan' },
		en: { name: 'Turkmenistan' },
		de: { name: 'Turkmenistan' },
		fo: { name: 'Turkmenistan' },
		nb: { name: 'Turkmenistan' },
		sv: { name: 'Turkmenistan' }
	},
	TC: {
		da: { name: 'Turks- og Caicosøerne' },
		en: { name: 'Turks and Caicos Islands' },
		de: { name: 'Turks- und Caicosinseln' },
		fo: { name: 'Turks- og Caicosoyggjar' },
		nb: { name: 'Turks- og Caicosøyene' },
		sv: { name: 'Turks- och Caicosöarna' }
	},
	TV: {
		da: { name: 'Tuvalu' },
		en: { name: 'Tuvalu' },
		de: { name: 'Tuvalu' },
		fo: { name: 'Tuvalu' },
		nb: { name: 'Tuvalu' },
		sv: { name: 'Tuvalu' }
	},
	TR: {
		da: { name: 'Tyrkiet' },
		en: { name: 'Turkey' },
		de: { name: 'Türkei' },
		fo: { name: 'Turkaland' },
		nb: { name: 'Tyrkia' },
		sv: { name: 'Turkiet' }
	},
	DE: {
		da: { name: 'Tyskland' },
		en: { name: 'Germany' },
		de: { name: 'Deutschland' },
		fo: { name: 'Týskland' },
		nb: { name: 'Tyskland' },
		sv: { name: 'Tyskland' }
	},
	UG: {
		da: { name: 'Uganda' },
		en: { name: 'Uganda' },
		de: { name: 'Uganda' },
		fo: { name: 'Uganda' },
		nb: { name: 'Uganda' },
		sv: { name: 'Uganda' }
	},
	UA: {
		da: { name: 'Ukraine' },
		en: { name: 'Ukraine' },
		de: { name: 'Ukraine' },
		fo: { name: 'Ukraina' },
		nb: { name: 'Ukraina' },
		sv: { name: 'Ukraina' }
	},
	HU: {
		da: { name: 'Ungarn' },
		en: { name: 'Hungary' },
		de: { name: 'Ungarn' },
		fo: { name: 'Ungarn' },
		nb: { name: 'Ungarn' },
		sv: { name: 'Ungern' }
	},
	UY: {
		da: { name: 'Uruguay' },
		en: { name: 'Uruguay' },
		de: { name: 'Uruguay' },
		fo: { name: 'Uruguay' },
		nb: { name: 'Uruguay' },
		sv: { name: 'Uruguay' }
	},
	US: {
		da: { name: 'USA' },
		en: { name: 'USA' },
		de: { name: 'USA' },
		fo: { name: 'USA' },
		nb: { name: 'USA' },
		sv: { name: 'USA' }
	},
	UZ: {
		da: { name: 'Usbekistan' },
		en: { name: 'Uzbekistan' },
		de: { name: 'Usbekistan' },
		fo: { name: 'Usbekistan' },
		nb: { name: 'Usbekistan' },
		sv: { name: 'Uzbekistan' }
	},
	VU: {
		da: { name: 'Vanuatu' },
		en: { name: 'Vanuatu' },
		de: { name: 'Vanuatu' },
		fo: { name: 'Vanuatu' },
		nb: { name: 'Vanuatu' },
		sv: { name: 'Vanuatu' }
	},
	VA: {
		da: { name: 'Vatikanstaten' },
		en: { name: 'Vatican City' },
		de: { name: 'Vatikanstadt' },
		fo: { name: 'Vatikanstaturin' },
		nb: { name: 'Vatikanstaten' },
		sv: { name: 'Vatikanstaten' }
	},
	VE: {
		da: { name: 'Venezuela' },
		en: { name: 'Venezuela' },
		de: { name: 'Venezuela' },
		fo: { name: 'Venesuela' },
		nb: { name: 'Venezuela' },
		sv: { name: 'Venezuela' }
	},
	EH: {
		da: { name: 'Vestsahara' },
		en: { name: 'Western Sahara' },
		de: { name: 'Westsahara' },
		fo: { name: 'Vestursahara' },
		nb: { name: 'Vest-Sahara' },
		sv: { name: 'Västsahara' }
	},
	VN: {
		da: { name: 'Vietnam' },
		en: { name: 'Vietnam' },
		de: { name: 'Vietnam' },
		fo: { name: 'Vjetnam' },
		nb: { name: 'Vietnam' },
		sv: { name: 'Vietnam' }
	},
	WF: {
		da: { name: 'Wallis og Futuna' },
		en: { name: 'Wallis and Futuna' },
		de: { name: 'Wallis und Futuna' },
		fo: { name: 'Wallis og Futuna' },
		nb: { name: 'Wallis og Futuna' },
		sv: { name: 'Wallis och Futuna' }
	},
	YE: {
		da: { name: 'Yemen' },
		en: { name: 'Yemen' },
		de: { name: 'Jemen' },
		fo: { name: 'Jemen' },
		nb: { name: 'Jemen' },
		sv: { name: 'Jemen' }
	},
	ZM: {
		da: { name: 'Zambia' },
		en: { name: 'Zambia' },
		de: { name: 'Sambia' },
		fo: { name: 'Sambia' },
		nb: { name: 'Zambia' },
		sv: { name: 'Zambia' }
	},
	ZW: {
		da: { name: 'Zimbabwe' },
		en: { name: 'Zimbabwe' },
		de: { name: 'Simbabwe' },
		fo: { name: 'Simbabvi' },
		nb: { name: 'Zimbabwe' },
		sv: { name: 'Zimbabwe' }
	},
	GQ: {
		da: { name: 'Ækvatorialguinea' },
		en: { name: 'Equatorial Guinea' },
		de: { name: 'Äquatorialguinea' },
		fo: { name: 'Ekvatorguinea' },
		nb: { name: 'Ekvatorial-Guinea' },
		sv: { name: 'Ekvatorialguinea' }
	},
	AT: {
		da: { name: 'Østrig' },
		en: { name: 'Austria' },
		de: { name: 'Österreich' },
		fo: { name: 'Eysturríki' },
		nb: { name: 'Østerrike' },
		sv: { name: 'Österrike' }
	},
	AX: {
		da: { name: 'Åland' },
		en: { name: 'Åland Islands' },
		de: { name: 'Ålandinseln' },
		fo: { name: 'Áland' },
		nb: { name: 'Åland' },
		sv: { name: 'Åland' }
	}
};

export default countries;
